module.exports = __webpack_public_path__ + "img/arrow-up-double-fill.3922d5fe.svg";